
define('jsx!components/login-public-tenant',[
	"react",
	"shared/client",
	"jsx!components/login-public-tenant/input-username",
	"jsx!components/login-public-tenant/input-password",
	"jsx!components/login-public-tenant/button-sign-in",
	"jsx!components/shared/login-image-picker",
], function (React, Client, UsernameComponent, PasswordComponent, SignInButtonComponent, AuthImagePickerComponent)
{
	return React.createClass({
		displayName: "LoginPublicTenant",
		clearMessageTimeout: null,
		getInitialState: function ()
		{
			/*
			 * Scan the URL for a potential default error message
			 */
			var requestMessage;
			try {
				/*
				 * Do we have a ref? If so, then we populate our own message.
				 */
				if (typeof window.appData.request.query.ref === "string") {
					switch (window.appData.request.query.ref) {
						case "idle":
							requestMessage = "You have been logged out due to inactivity.";
							break;
						case "post_signup":
							requestMessage = "Your account has been created. Please login to continue.";
							break;
					}
				} else {
					requestMessage = window.appData.request.query.message || null;
				}
			} catch (e) {
				// NO-OP
			}

			this.resetClearmessageTimeout();
			localStorage.removeItem('teams-meeting');

			return {
				"username": null,
				"password": null,
				"show_password_input": false,
				"request_in_progress": false,
				"validating": false,
				"message": requestMessage,
				"authentication_method": null,
				"image_set": [],
				"show_auth_image_picker": false,
				"resend_verification_email_recipient" : null
			};
		},
		resetClearmessageTimeout: function() {
			var self = this;
			if(this.clearMessageTimeout) {
				window.clearTimeout(this.clearMessageTimeout);
			}
			this.clearMessageTimeout = window.setTimeout(function () {
				self.setState({
					message: null
				});
				self.clearMessageTimeout = null;
			}, 10000);
		},
		setErrorMessage: function (v)
		{
			this.resetClearmessageTimeout();
			this.setState({
				"message": v
			});
		},
		setUsername: function (v)
		{
			this.setState({
				"username": v
			});
		},
		setPassword: function (v)
		{
			this.setState({
				"password": v
			});
		},
		setAuthenticationMethod: function (v)
		{
			this.setState({
				"authentication_method": v
			});
		},
		handleClickOnSignInButton: function ()
		{	
			if(this.state.validating) {
				return;
			}
			try{

				/**
				 * Check if username has all valid characters. Does not mean if username will exist or not, means that it will be valid for request
				 * Then, fire a exist request to see if the username exist
				 * After checking username, direct user to appropriate authentication method: password or image
				 * Then, check the password/image and let the user in or reject if any of those field are wrong.
				 */
				if (this.state.username !== null && this.state.show_password_input === false && this.state.authentication_method === null) {
					this.setValidating(true);

					if (typeof this.state.username !== "string" || this.state.username.length == 0) {
						throw new Error("Please enter a username.");
					}
	
					const validUsername = new RegExp(/^[\p{L}0-9!#$%&*\\'+^?`{}|~@_\.\-\/]+$/iu);
					if (!validUsername.test(this.state.username)) {
						throw new Error("Username contains an invalid character.");
					}
	
					if (this.state.username.length > 255) {
						throw new Error("Username is too long.");
					}
	
					this.validateUsernameExists();

				} else if (this.state.username !== null && this.state.authentication_method !== null) {
					var authValue = this.state.authentication_method === "image_set" ? this.state.image_set : this.state.password;
					this.executeSignInRequest(this.state.username, this.state.authentication_method, authValue);
				}
			} catch (err) {
				this.setState({
					'show_password_input': false,
					'validating': false,
					'message': err.message
				});
			}
		},
		validateUsernameExists: function ()
		{
			// add this to helper? Might not be too helpful
			var self = this;
			var requestId = Date.now();
			this.validationRequestId = requestId;

			$.get(window.appData.client.api_url + "/users/exists", {
				"username": this.state.username
			})
			.done(function (response) {
				if (self.validationRequestId !== requestId) {
					return;
				}

				/*
				 * If the user has been deleted, let them know.
				 */
				if (typeof response.data.deleted_at === "string") {
					self.setState({
						"message": "This account has been deactivated."
					});
					return;
				}

				self.setState({
					"message": null
				});

				/*
				 * If the user can be authenticated via image-set login.
				 * let the parent component know.
				 */
				if (response.data.supports_image_set_auth) {
					self.setState({
						"password": null
					});
					self.setAuthenticationMethod("image_set");
				} else {
					self.setAuthenticationMethod("password");
				}
			})
			.fail(function (jqXHR) {
				if (self.validationRequestId !== requestId) {
					return;
				}
			})
			.always(function () {
				self.setValidating(false);
				self.setUsername(self.state.username);
				self.validationRequestId = null;
				self.state.authentication_method === "image_set" ? self.showAuthImagePicker() : self.showPasswordInput();
			});
		},
		handleClickOnSignInWithGoogleButton: function ()
		{
			window.location = window.appData.client.api_url + "/login/external/google";
		},
		handleClickOnSignInWithMicrosoftButton: function ()
		{
			window.location	= window.appData.client.api_url + "/login/external/microsoft";
		},
		handleEnterKeyUp: function ()
		{
			this.handleClickOnSignInButton();
		},
		executeSignInRequest: function (username, authentication_method, authentication_value)
		{
			var self = this;
			this.setState({
				"message": null,
				"request_in_progress": true
			});
			var trialURI = "https://" + window.location.host + "/start-trial";
			var returnTo  = window.appData.request.query.return_to;
			$.post('/login', {
				"username": username,
				"authentication_method": authentication_method || "password",
				"authentication_value": authentication_value,
				"return_to": returnTo ? returnTo : trialURI
			})
			.done(function (response)
			{
				if (response.error) {
					if (/not.+verified/.test(response.error)) {
						self.setState({
							"message":response.error,
							"resend_verification_email_recipient":username,
						});
					} else {
						self.setState({
							"message":response.error
						});
					}
				} else {
					window.location = response.redirect_to;
				}
			})
			.fail(function (jqXHR)
			{
				if ((jqXHR.responseText || "").indexOf("credentials were incorrect") > -1) {
					self.setState({
						"message": "Invalid username or password."
					});
				} else if (jqXHR.responseText.indexOf("The username format is invalid.") > -1) {
					self.setState({
						"message": "The username contains an invalid character."
					});
				}  else if (jqXHR.responseText.indexOf("The authentication value field is required when authentication method is present") > -1) {
					self.setState({
						"message": "Password cannot be empty"
					});
				} else {
					self.setState({
						"message": jqXHR.responseText || "Failed to execute sign in request."
					});
				}
			})
			.always(function ()
			{
				self.setState({
					"request_in_progress": false
				});
			});
		},
		showActivityModal: function ()
		{
			if($('#activity-modal').length > 0) {
				$('#activity-modal').modal({
					"keyboard": false,
					"backdrop": "static"
				});
			}
			
		},
		hideActivityModal: function ()
		{
			if($('#activity-modal').length > 0) {
				$('#activity-modal').modal('hide');	
			}
		},
		componentDidUpdate: function (prevProps, prevState)
		{
			var self = this;

			// If we have just finished selecting two images for image_set auth,
			// trigger a login.
			if (self.state.authentication_method === "image_set") {
				if (prevState.image_set.length == 1 && self.state.image_set.length == 2) {
					
					// We implement a short delay so it does not look jarring
					window.setTimeout(function () {
						// We execute the login using the image titles, not the whole object.
						var authValue = self.state.image_set.map(function (image) {
							return image.title
						});
						var promise = self.executeSignInRequest(self.state.username, self.state.authentication_method, authValue)
						
						// If we the auth failed, clear the selected set, but show the image picker again.
						promise.fail(function (jqXHR) {
							// We clear out image_set first, and then set message because
							// message gets wiped out when the component detects a change
							// in auth values.
							self.setState({ "image_set": [], }, function () {
								self.setState({ "message": "Oops, that's not it, try again!" });
							});
						});
					}, 500);
				}
			}

			// Should we show the activity modal?
			if (!prevState.request_in_progress && self.state.request_in_progress === true) {
				self.showActivityModal();
			} else if (!self.state.request_in_progress && prevState.request_in_progress === true) {
				self.hideActivityModal();
			}
		},
		componentDidMount: function () {
            try { 	
				AppleID.auth.init({
	                clientId: 'com.buncee.universal.web',
	                scope: 'name email',
	                redirectURI: window.appData.client.common_url + "/login/external/apple",
	                usePopup: false
	            });
	            
	            // Apple doesnt let us style the picker normally so we do hacky stuff
	            var $signInButton = $("#appleid-signin")[0];

	            // Remove the existing text since we can't change font size on it
	            var $textSVG = $signInButton.querySelector('svg');
	            $textSVG.remove();

	            // Set the right height for the bounding rectangle
	            var $rectSVG = $signInButton.querySelector('svg');
	            $rectSVG.setAttribute('height', '60');

	            // Inject correctly sized logo and text
	            var $signInButtonInner = $signInButton.children[0].children[1];
	            var appleLogo = document.createElement('img');
	            appleLogo.className = 'apple-logo';
	            appleLogo.setAttribute('src', Client.cdnURL("/images/web/apple-tile.png"));
	            var appleText = document.createElement('span');
	            appleText.className = 'apple-text';
	            appleText.innerHTML = "Sign In with Apple";
	            $signInButtonInner.append(appleLogo);
	            $signInButtonInner.append(appleText);
            } catch(e) {
            	// Do nothing
            }
		},
		renderAuthImagePicker: function ()
		{
			var self = this;

			return (
				React.createElement("div", {className: "modal-wrapper"}, 
					React.createElement("div", {className: "overlay"}), 
					React.createElement("div", {className: "modal modal-auth-image-picker"}, 

						React.createElement("h2", null, "Select Your Password Images"), 
						 this.renderMessage(), 

						React.createElement(AuthImagePickerComponent, {
							selected_images:  self.state.image_set, 
							onChange:  function (selected_images) {
								self.setState({ image_set: selected_images });
							}}), 

						React.createElement("button", {className: "btn-close", onClick:  function () {
							self.setState({
								"image_set": [],
								"show_auth_image_picker": false,
								"authentication_method": null
							});
						}, "aria-label": "close"}, 
							React.createElement("span", {className: "dashboard-icon-close"})
	                    )

					)
				)
			);
		},
		resendVerificationEmail: function () {
			var self = this;
			if (this.state.resend_verification_email_recipient) {
				var email = this.state.resend_verification_email_recipient.replace('+','%2B');
				const uri = '/verify-email/resend?email=' + email;
				return $.get(uri)
				.done(function (response) {
					self.setState({
						"message": ("Verification email has been sent to " + self.state.resend_verification_email_recipient)
					});
				})
				.fail(function (jqXHR) {
					self.setState({
						"message": "Failed to send verification email. Please contact support"
					});
				})
			}
		},
		openOlark: function () {
			// Trigger the chat window to open if we can find the button, else redirect to support page
			var olarkButton = document.getElementsByClassName("olark-launch-button")[0];
			if (olarkButton) {
				olarkButton.click();
			} else {
				window.open("https://app.edu.buncee.com/support/#");
			}
		},
		renderMessage: function ()
		{
			if (typeof this.state.message == "string" && this.state.message.length > 0) {
				if  (/not.+verified/.test(this.state.message)) {
					return (
						React.createElement("div", {className: "alert alert-danger"}, 
							"Your account has not been verified. Please check your email to verify your account.", 
							React.createElement("br", null), 
							"To re-send the verification email, click ", React.createElement("a", {onClick: this.resendVerificationEmail}, "here"), "."
						)
					)
				} else if (this.state.message.includes(this.state.resend_verification_email_recipient)) {
					return (
						React.createElement("div", {className: "alert alert-success"}, 
							"Verification email has been sent to ", this.state.resend_verification_email_recipient, ". If for some reason, you don't see it, call us at +1 (929) 274-0933 between 9-5 EST" + ' ' +
                            "or click ", React.createElement("a", {onClick: this.openOlark, onTouchEnd: this.openOlark}, "here"), " to chat with us."
						)
					)
				} else if (/verified|created/.test(this.state.message) 
					|| /successfully logged out/.test(this.state.message)
					|| /email has been sent/.test(this.state.message)) { 
					return (
						React.createElement("div", {className: "alert alert-success"}, 
							 this.state.message
						)
					)
				} else {
					return (
						React.createElement("div", {className: "alert alert-danger"}, 
							 this.state.message
						)
					);
				}
			}
		},
		showPasswordInput: function() {
			this.setState({
				show_password_input: true,
			})
		},
		hidePasswordInput: function() {
			this.setState({
				show_password_input: false,
				authentication_method: null
			})
		},
		setValidating: function(validating) {
			this.setState({
				validating: validating
			})
		},
		showAuthImagePicker: function() {
			this.setState({
				show_auth_image_picker: true
			})
		},
		render: function ()
		{
			var self = this;
			return (
				React.createElement("div", {className: "form login-form"}, 
					 this.renderMessage(), 
					
					React.createElement(UsernameComponent, {
						username: this.state.username, 
						setUsername: this.setUsername, 
						setAuthenticationMethod: this.setAuthenticationMethod, 
						setErrorMessage: this.setErrorMessage, 
						handleEnterKeyUp: this.handleEnterKeyUp, 
						hidePasswordInput: this.hidePasswordInput}
						), 
					
					
						this.state.authentication_method !== "image_set" && this.state.show_password_input ? 
						React.createElement(PasswordComponent, {
							password: this.state.password, 
							setPassword: this.setPassword, 
							handleEnterKeyUp: this.handleEnterKeyUp}) :
						null, 
					

					
						// Show the auth image picker
						(!this.state.request_in_progress)
						&& this.state.username
						&& this.state.authentication_method === "image_set"
						&& this.state.show_auth_image_picker
						&& this.renderAuthImagePicker(), 
					
					
					
						// Show the sign in button for username/password login
						React.createElement(SignInButtonComponent, {
							username: this.state.username, 
							password: this.state.password, 
							validating: this.state.validating, 
							onClick: this.handleClickOnSignInButton}), 
					

					React.createElement("div", {className: "row-or"}, 
						React.createElement("span", {className: "or"}, "or")
					), 

					React.createElement("div", {className: "form-group sso"}, 
						React.createElement("button", {className: "btn btn-google", id: "btn-sign-in-google", onClick: this.handleClickOnSignInWithGoogleButton}, 
							React.createElement("span", {className: "icons8-google"}), 
							"Sign In with Google"
						), 
						React.createElement("button", {className: "btn btn-microsoft", id: "btn-sign-in-microsoft", onClick: this.handleClickOnSignInWithMicrosoftButton}, 
							"Sign In with Microsoft"
						), 
						React.createElement("button", {id: "appleid-signin", "data-color": "black", "data-border": "true", "data-type": "sign in"}, 
							"Sign In With Apple ID"
						)
					)
				)
			);
		}
	});
});
